import React, { useEffect, useState } from "react";
import logo from "../../images/logo.png";
import imoje from "../../images/imoje.png";

export default function Step3No({ onClose }) {
  const [userName, setUserName] = useState("");

  useEffect(() => {
    const storedName = localStorage.getItem("username"); // make sure key matches Step2
    if (storedName) setUserName(storedName);
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="relative w-full max-w-md bg-white rounded-2xl shadow-lg p-6 sm:p-8 text-center">

        {/* Close Button */}
        <button
          type="button"
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-2xl font-bold"
          onClick={onClose}
        >
          ×
        </button>

        {/* Logo */}
        <img
          src={logo}
          alt="Logo"
          className="h-16 mx-auto mb-4 object-contain"
        />

        {/* Sad Emoji */}
        {/* <img
          src={imoje}
          alt="Sad"
          className="h-12 sm:h-16 mx-auto mb-4 object-contain"
        /> */}

        {/* Optional Greeting */}
        {/* {userName && (
          <p className="text-sm text-gray-800 font-medium mb-2">
            Hello, {userName}! 👋
          </p>
        )} */}

        {/* Heading */}
        <h2 className="text-lg font-semibold text-gray-800 mb-3">
          Sorry! You are not suitable for weight loss injections 🚫
        </h2>

        {/* Description */}
        <p className="text-sm text-gray-700 mb-3 leading-relaxed px-4">
          If you believe there might be errors in your responses, kindly click
          back to review them.
        </p>

        {/* Caution */}
        <p className="text-sm text-gray-700 leading-relaxed px-4 mb-6">
          <span className="text-red-600 font-semibold">Caution: </span>
          Providing inaccurate information during a clinical consultation could
          be hazardous for your health.
        </p>

        {/* Back Button */}
        <button
          onClick={onClose}
          className="mt-4 w-full bg-[#35C3D9]  hover:bg-[#35C3D9]  text-white font-semibold py-2 rounded-lg transition-colors"
        >
          ← Back
        </button>
      </div>
    </div>
  );
}
